import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['commitee']);

export const commiteeQueryKeys = {
  all: builder(),
  commitees: builder('commitees'),
  commitee: builder('commitee'),
};
